import { ca } from '@cian/analytics';
import { createLabel } from '../../utils';

export function trackShowPhone(action: string) {
  return (developerId: number) =>
    ca('eventSite', {
      name: 'oldevent',
      category: 'Phones',
      action,
      label: createLabel(developerId),
      useLastProducts: true,
    });
}
